<template>
    <div>
        <h1 class="d-flex justify-center font-weight-light primary--text mb-4">Comisiones</h1>
        <v-card>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-check-all
                                    </v-icon>
                                    Nº Activaciones
                                </td>
                                <td>41</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-podium
                                    </v-icon>
                                    Segmento
                                </td>
                                <td>PLATINO</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-seal-variant
                                    </v-icon>
                                    Bono Imagen
                                </td>
                                <td>500 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-cash
                                    </v-icon>
                                    Comisiones
                                </td>
                                <td>1.662,50 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-sigma
                                    </v-icon>
                                    Total Pago
                                </td>
                                <td>2.162,50 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-trophy-variant
                                    </v-icon>
                                    TOP
                                </td>
                                <td>NO</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-seal-variant
                                    </v-icon>
                                    Bono Imagen
                                </td>
                                <td>500 €</td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-cash
                                    </v-icon>
                                    Comisiones
                                </td>
                                <td>1.662,50 €</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    <v-icon left>
                                        mdi-sigma
                                    </v-icon>
                                    Total Pago
                                </td>
                                <td>2.162,50 €</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>

        </v-card>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'LowiPayments',
    data: () => ({

    }),
}
</script>
